import {Permission} from './permission';

export class Permissions {
  private static DPT_UNIT = 'WebDepotUnit';
  private static DPT_SPOOL = 'WebDepotSpool';
  private static DPT_PUBLI = 'WebDepotMailing';
  private static DPT_LRE = 'WebDepotLRE';
  private static TRACKING = 'TrackingDepot';
  private static WORKFLOW = 'WfValidSign';
  private static AUTO_REFRESH = 'WebAutoRefresh';
  private static TAB_LRE = 'WebTabLre';
  private static TAB_WAITING = 'WebWorkFlow';
  private static EDIT_GRP_ADDRESS = 'WebEditGroupAddress';
  webDepotUnit: Permission;
  webDepotSpool: Permission;
  webDepotMailing: Permission;
  webDepotLRE: Permission;
  trackingDepot: Permission;
  wfValidSign: Permission;
  webAutoRefresh: Permission;
  webTabLre: Permission;
  webTabWaiting: Permission;
  webEditGroupAddress: Permission;

  constructor(permissions: any) {
    this.init();
    if (permissions) {
      for (const permission of permissions) {
        if (permission.sFonctId) {
          switch (permission.sFonctId) {
            case Permissions.DPT_UNIT:
              this.webDepotUnit.available = permission.bAccess;
              this.webDepotUnit.withAction = permission.bAction;
              break;
            case Permissions.DPT_SPOOL:
              this.webDepotSpool.available = permission.bAccess;
              this.webDepotSpool.withAction = permission.bAction;
              break;
            case Permissions.DPT_PUBLI:
              this.webDepotMailing.available = permission.bAccess;
              this.webDepotMailing.withAction = permission.bAction;
              break;
            case Permissions.DPT_LRE:
              this.webDepotLRE.available = permission.bAccess;
              this.webDepotLRE.withAction = permission.bAction;
              break;
            case Permissions.TRACKING:
              this.trackingDepot.available = permission.bAccess;
              this.trackingDepot.withAction = permission.bAction;
              break;
            case Permissions.WORKFLOW:
              this.wfValidSign.available = permission.bAccess;
              this.wfValidSign.withAction = permission.bAction;
              break;
            case Permissions.AUTO_REFRESH:
              this.webAutoRefresh.available = permission.bAccess;
              this.webAutoRefresh.withAction = permission.bAction;
              break;
            case Permissions.TAB_LRE:
              this.webTabLre.available = permission.bAccess;
              this.webTabLre.withAction = permission.bAction;
              break;
            case Permissions.TAB_WAITING:
              this.webTabWaiting.available = permission.bAccess;
              this.webTabWaiting.withAction = permission.bAction;
              break;
            case Permissions.EDIT_GRP_ADDRESS:
              this.webEditGroupAddress.available = permission.bAccess;
              this.webEditGroupAddress.withAction = permission.bAction;
              break;
          }
        }
      }
    }
  }

  private init(): void {
    this.webDepotUnit = new Permission();
    this.webDepotSpool = new Permission();
    this.webDepotMailing = new Permission();
    this.webDepotLRE = new Permission();
    this.trackingDepot = new Permission();
    this.wfValidSign = new Permission();
    this.webAutoRefresh = new Permission();
    this.webTabLre = new Permission();
    this.webTabWaiting = new Permission();
    this.webEditGroupAddress = new Permission();
  }
}
